import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { resetState } from './projectListSlice';
import { useDispatch, useSelector } from 'react-redux';
import { getProjectList, getPddProjectList } from '../../../api/projectListApi';
import ProjectListContainer from './structure/ProjectListContainer';
import { resetState as resetReadOnly } from '../slice/readOnlySlice';
import { resetOpenAssetState } from '../assetSwitcher/OpenAssetSlice';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { setProjectOpen } from '../../../layout/app-container/containerSlice';
import { setProjectClose } from '../../../layout/app-container/containerSlice';
import { getPddOpenProjectApi } from '../../../utils/pddApiHelper';
import React from 'react';

const ProjectListHome = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const projectlistState = useSelector((state) => state.projectList);
  const [projectList, setProjectList] = useState([]);

  useEffect(() => {
    dispatch(setProjectClose());
    dispatch(resetOpenAssetState());
    
    // Call the appropriate API based on service line
    if (props.serviceLine && props.serviceLine.name === 'Pdd') {
      dispatch(getPddProjectList());
    } else {
      dispatch(getProjectList());
    }
    
    dispatch(resetReadOnly());
  }, [dispatch, props.serviceLine]);

  useEffect(() => {
    if (
      projectlistState.type === 'SUCCESS' &&
      projectlistState.data.length > 0
    ) {
      let pList = projectlistState.data.map((m) => {
        return {
          projectName: m.projectName,
          projectNumber: m.projectNumber,
          projectRoles: m.projectRoles,
          projectDescription: m.projectDescription,
          projectIdent: m.projectIdent,
          isFavourite: m.favoriteProject,
          status: m.status,
          serviceLine: m.serviceLine,
          projectLanguageCode: m.languageCode,
        };
      });
      setProjectList(pList);
      dispatch(resetState());
    }
  }, [dispatch, projectlistState.data, projectlistState.type]);

  const openProject = (data) => {
    navigate(`${props.serviceLine.root}/project/project-dashboard`);
    
    // Use TDD API for PDD projects
    const apiEndpoint = getPddOpenProjectApi(props.serviceLine, data.row);
    
    const projectScope = {
      serviceLine: props.serviceLine.name.toLowerCase(),
      api: apiEndpoint,
      isProjectScope: true,
      projectIdent: data.row.projectIdent,
      projectName: data.row.projectName,
      isReadOnly: data.row.isReadOnly,
      currentProjectRole: 'Default',
      projectLanguageCode: !!data.row.languageCode
        ? data.row.languageCode
        : 'de',
    };
    
    dispatch(setProjectOpen(projectScope));
  };

  return (
    <div className="h-100">
      <ProjectListContainer
        list={projectList}
        serviceLine={props.serviceLine}
        onProjectOpen={(data) => openProject(data)}
        onProjectCreate={() => {
          // Call the appropriate API based on service line
          if (props.serviceLine && props.serviceLine.name === 'Pdd') {
            dispatch(getPddProjectList());
          } else {
            dispatch(getProjectList());
          }
        }}
      />
    </div>
  );
};

ProjectListHome.propTypes = {
  serviceLine: PropTypes.string,
  onProjectCreate: PropTypes.func,
};

export default ProjectListHome;
